<template>
  <div class="services-page">
    <section class="list-header">
      <div class="title-row">
        <v-btn icon class="back-button" @click="$router.push('/home')">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <h1>Serviços úteis</h1>
      </div>
      <v-btn icon class="refresh-button" @click="load">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </section>

    <section class="service-section">
      <div class="section-title">
        <v-icon color="primary">mdi-trash-can-outline</v-icon>
        <h2>Coleta de lixo</h2>
      </div>
      <article v-for="item in schedules" :key="item.id" class="service-card">
        <div>
          <strong>{{ wasteLabel(item.waste_type) }}</strong>
          <span>{{ weekdayLabel(item.weekday) }} {{ timeRange(item) }}</span>
          <small>{{ item.route_name || item.notes || "Confira o horário da sua rua/núcleo." }}</small>
        </div>
      </article>
      <div v-if="!schedules.length" class="empty-inline">Nenhum horário cadastrado.</div>
    </section>

    <section class="service-section">
      <div class="section-title">
        <v-icon color="primary">mdi-map-marker-radius-outline</v-icon>
        <h2>Lixeiras e pontos de descarte</h2>
      </div>
      <article v-for="point in trashPoints" :key="point.id" class="service-card">
        <div>
          <strong>{{ point.name }}</strong>
          <span>{{ point.description || "Ponto cadastrado no mapa operacional." }}</span>
          <small v-if="point.latitude && point.longitude">{{ point.latitude }}, {{ point.longitude }}</small>
        </div>
      </article>
      <div v-if="!trashPoints.length" class="empty-inline">Nenhum ponto de lixeira cadastrado.</div>
    </section>

    <section class="service-section">
      <div class="section-title">
        <v-icon color="primary">mdi-phone-alert-outline</v-icon>
        <h2>Telefones de emergência</h2>
      </div>
      <article v-for="contact in contacts" :key="contact.id" class="contact-card">
        <div>
          <strong>{{ contact.name }}</strong>
          <span>{{ contact.category }} {{ contact.available_hours ? `- ${contact.available_hours}` : "" }}</span>
          <small>{{ contact.notes }}</small>
        </div>
        <a :href="`tel:${contact.phone}`">
          <v-icon small>mdi-phone</v-icon>
          {{ contact.phone }}
        </a>
      </article>
      <div v-if="!contacts.length" class="empty-inline">Nenhum telefone cadastrado.</div>
    </section>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "BoaruaDailyServices",
  data() {
    return {
      schedules: [],
      trashPoints: [],
      contacts: [],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      const profile = JSON.parse(localStorage.getItem("associationProfile") || "{}");
      if (!profile.tenant_id) return;
      const params = { tenant_id: profile.tenant_id, limit: 100 };
      const [schedules, points, contacts] = await Promise.allSettled([
        axios.get("/waste-schedules", { params }),
        axios.get("/operational-points", { params: { ...params, search: JSON.stringify({ type: "trash_bin" }) } }),
        axios.get("/emergency-contacts", { params }),
      ]);
      this.schedules = this.extract(schedules);
      this.trashPoints = this.extract(points);
      this.contacts = this.extract(contacts);
    },
    extract(result) {
      if (result.status !== "fulfilled") return [];
      const content = result.value.data && result.value.data.content;
      if (Array.isArray(content)) return content;
      return content && Array.isArray(content.data) ? content.data : [];
    },
    wasteLabel(type) {
      return {
        organic: "Lixo orgânico",
        dry: "Lixo seco",
        recyclable: "Reciclável",
        green: "Resíduos verdes",
      }[type] || type || "Coleta";
    },
    weekdayLabel(day) {
      return {
        monday: "Segunda",
        tuesday: "Terça",
        wednesday: "Quarta",
        thursday: "Quinta",
        friday: "Sexta",
        saturday: "Sábado",
        sunday: "Domingo",
      }[day] || day || "";
    },
    timeRange(item) {
      if (item.starts_at && item.ends_at) return `das ${item.starts_at} às ${item.ends_at}`;
      if (item.starts_at) return `a partir das ${item.starts_at}`;
      return "";
    },
  },
};
</script>

<style scoped lang="scss">
.services-page {
  min-height: 100%;
  padding: 0 16px 18px;
  color: #111827;
}

.list-header {
  min-height: 72px;
  margin: 0 -16px 12px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  border-bottom: 1px solid #edf0ed;

  h1 {
    margin: 0;
    font-size: 24px;
  }
}

.title-row,
.section-title,
.contact-card {
  display: flex;
  align-items: center;
}

.title-row,
.section-title {
  gap: 10px;
}

.back-button,
.refresh-button {
  background: #f5f7f5;
  border: 1px solid #dfe7df;
  border-radius: 12px;
}

.service-section {
  margin-bottom: 14px;
}

.section-title {
  margin-bottom: 10px;

  h2 {
    margin: 0;
    font-size: 18px;
  }
}

.service-card,
.contact-card,
.empty-inline {
  background: #ffffff;
  border: 1px solid #e1e8e2;
  border-radius: 16px;
}

.service-card,
.contact-card {
  margin-bottom: 9px;
  padding: 13px 14px;
}

.service-card strong,
.service-card span,
.service-card small,
.contact-card strong,
.contact-card span,
.contact-card small {
  display: block;
}

.service-card span,
.service-card small,
.contact-card span,
.contact-card small {
  color: #66736b;
  font-size: 12px;
}

.contact-card {
  justify-content: space-between;
  gap: 12px;

  div {
    min-width: 0;
  }

  a {
    min-height: 36px;
    padding: 0 10px;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    color: #ffffff;
    background: #057a3d;
    border-radius: 11px;
    font-size: 12px;
    font-weight: 800;
    text-decoration: none;
    white-space: nowrap;
  }
}

.empty-inline {
  padding: 16px;
  color: #66736b;
  font-size: 13px;
  text-align: center;
}
</style>
